import { HTTP, ENDPOINT } from "../config";
import { fetchFromLawfeed } from "../fetchFromLawfeed";

// Obtener todos los clientes
export const getAllClients = async (organization = "", limit = "10", skip = "0") => {
    console.log(organization, limit, skip);
    const response = await fetchFromLawfeed({
        method: HTTP.GET,
        endpoint: ENDPOINT.ALL_CLIENTS,
        queryParams: [
            { org: organization },
            { limit: limit },
            { skip: skip }
        ]
    });

    return response.list || [];
};




